<template>
  <div class="app-container">
  </div>
</template>

<script>
import { useScreenState } from "../../store";
import { accountBase } from "../../utils/paccount";
let client_id = process.env.VUE_APP_ACCOUNT_CLIENT_ID

export default {
    name: "Register",
    data() {
        return {
            screenState: useScreenState(),
        };
    },
    beforeMount() {
        if (this.$route.query.returnurl)
            window.localStorage.setItem('returnurl', this.$route.query.returnurl)
        else
            window.localStorage.removeItem('returnurl')
        this.$router.back()
        let href = accountBase + '/#/register?client_id=' + client_id + '&return_url=' + encodeURIComponent(
            'https://' + window.location.host + '/account/oauth2')
        if (this.$route.query.utm_source)
            href = `${href}&utm_source=${this.$route.query.utm_source}`
        if (this.$route.query.utm_campaign)
            href = `${href}&utm_campaign=${this.$route.query.utm_campaign}`
        if (this.$route.query.utm_medium)
            href = `${href}&utm_medium=${this.$route.query.utm_medium}`
        window.location.href = href
    },
};
</script>

<style scoped>
</style>